import { Component, OnInit } from '@angular/core';
import { StepType, RegistrationStepService, PartnerInviteModel, ErrorStateService, RegistrationStepQuery } from '@fgb/core';

@Component({
  selector: 'fgb-registration-partner-invite',
  templateUrl: './registration-partner-invite.component.html',
  styleUrls: ['./registration-partner-invite.component.scss'],
})
export class RegistrationPartnerInviteComponent implements OnInit {
  readonly stepType: StepType = StepType.ProcessPartnerRequest;
  partnerKeys: PartnerInviteModel;

  constructor(
    private registrationStepService: RegistrationStepService,
    private registrationStepQuery: RegistrationStepQuery,
    public errorService: ErrorStateService
  ) {}

  ngOnInit() {
    const data = this.registrationStepQuery.getStep(this.stepType);
    if (data) {
      this.partnerKeys =
        ({
          PartnerCode: data.Data.PartnerCode ?? '',
          PartnerSecretCode: data.Data.PartnerSecretCode ?? '',
        } as PartnerInviteModel);
    }
  }

  submitStep() {
    this.errorService.clearErrors();
    if (this.partnerKeys.PartnerCode === '' && this.partnerKeys.PartnerSecretCode === '') {
      this.errorService.addError('Please enter the partner code and the partner secret code received');
    } else if (this.partnerKeys.PartnerCode === '') {
      this.errorService.addError('Please enter the partner code received');
    } else if (this.partnerKeys.PartnerSecretCode === '') {
      this.errorService.addError('Please enter the partner secret code received');
    } else {
      const stepData = this.partnerKeys;
      if (stepData.PartnerCode.length > 0 && stepData.PartnerSecretCode.length > 0) {
        this.registrationStepService.submitRegistrationStepData(this.stepType, stepData).toPromise();
      }
    }
  }
}
